import React from 'react';

const VoteIcon = (props) => (
  <svg width={12} height={12} viewBox="0 0 12 12" {...props}>
    <path
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
      d="M5.899 0C4.598 0 3.654.979 3.654 2.325c0 .069.003.152.008.248.024.463.011.79-.367 1.116a16.135 16.135 0 0 0-1.48 1.457H.1v5.88l1.507-.007.491-.002h1.178c.033.026.066.055.101.084.379.308 1.085.884 2.233.884h2.336c1.481 0 2.416-.886 2.563-1.821.456-.379.735-.919.804-1.455l.01-.077c.344-.384.583-.904.583-1.541 0-.712-.237-1.27-.594-1.66-.107-1.021-.927-1.764-1.989-1.764H8.11V2.458C8.11 1.034 7.179 0 5.899 0m0 1.5c.575 0 .711.562.711.958v2.214L6 5.167h3.323c.056 0 .502.016.502.495v.6c.004 0 .581.001.581.829 0 .627-.581.784-.581.784v.644s-.085.661-.795.661v.726c0 .198-.357.579-1.084.579H5.61c-1.129 0-1.37-.968-2.165-.968H2.09l-.49.002V6.646h.913s.669-.88 1.761-1.82c1.092-.94.88-2.104.88-2.501 0-.395.169-.825.745-.825"
    />
  </svg>
);

export default VoteIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/VoteIcon.js